var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdjustments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C1.34315 0 0 1.34315 0 3C0 4.30622 0.834808 5.41746 2 5.82929V23C2 23.5523 2.44772 24 3 24C3.55229 24 4 23.5523 4 23L4 5.82929C5.16519 5.41746 6 4.30622 6 3C6 1.34315 4.65685 0 3 0ZM2 3C2 2.44772 2.44772 2 3 2C3.55228 2 4 2.44772 4 3C4 3.55228 3.55228 4 3 4C2.44772 4 2 3.55228 2 3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14.1707V1C8 0.447716 8.44771 0 9 0C9.55228 0 10 0.447716 10 1L10 14.1707C11.1652 14.5825 12 15.6938 12 17C12 18.3062 11.1652 19.4175 10 19.8293V23C10 23.5523 9.55229 24 9 24C8.44772 24 8 23.5523 8 23V19.8293C6.83481 19.4175 6 18.3062 6 17C6 15.6938 6.83481 14.5825 8 14.1707ZM8 17C8 16.4477 8.44772 16 9 16C9.55228 16 10 16.4477 10 17C10 17.5523 9.55228 18 9 18C8.44772 18 8 17.5523 8 17Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 3.17071V1C14 0.447716 14.4477 0 15 0C15.5523 0 16 0.447716 16 1V3.17071C17.1652 3.58254 18 4.69378 18 6C18 7.30622 17.1652 8.41746 16 8.82929V23C16 23.5523 15.5523 24 15 24C14.4477 24 14 23.5523 14 23V8.82929C12.8348 8.41746 12 7.30622 12 6C12 4.69378 12.8348 3.58254 14 3.17071ZM14 6C14 5.44772 14.4477 5 15 5C15.5523 5 16 5.44772 16 6C16 6.55228 15.5523 7 15 7C14.4477 7 14 6.55228 14 6Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 9.17071V1C20 0.447716 20.4477 0 21 0C21.5523 0 22 0.447716 22 1L22 9.17071C23.1652 9.58254 24 10.6938 24 12C24 13.3062 23.1652 14.4175 22 14.8293V23C22 23.5523 21.5523 24 21 24C20.4477 24 20 23.5523 20 23V14.8293C18.8348 14.4175 18 13.3062 18 12C18 10.6938 18.8348 9.58254 20 9.17071ZM20 12C20 11.4477 20.4477 11 21 11C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13C20.4477 13 20 12.5523 20 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdjustments);
export default __webpack_public_path__ + "static/media/Adjustments.9b8d0fcf7b876f62fd228dc1cec32c87.svg";
export { ForwardRef as ReactComponent };